import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { UserData } from "@/entities/User";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

interface Params {
  id: string | number;
  abortController?: AbortController;
}

export const fetchUserProfile = createAsyncThunk<UserData, Params, ThunkConfig<ApiError>>(
  "fetchUserProfile",
  async ({ id, abortController }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<UserData>(`/api/users/${id}`, {
        signal: abortController?.signal,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
